import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { Button } from "@material-ui/core";
import { useSnackbar } from "notistack";
import { Edit, VideoCall } from "@material-ui/icons";
import { putVideo } from "../../../services";

const QUERY_NAME = "Sekilas%20Tentang%20Kami";

const initVideoState = {
  video: "",
  old_video: "",
  videoRead: "",
};

const VideoTentangKami = ({ onHideText, onShowTextAndVideo }: any) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loadingState, setLoadingState] = useState(false);
  const [videoState, setVideoState] = useState<any>(initVideoState);
  const [isEditState, setIsEditState] = useState(false);

  const handleVideoChange = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      setVideoState({
        ...videoState,
        video: event.target.files[0],
        videoRead: URL.createObjectURL(event.target.files[0]),
      });
    }
  };

  const handleSaveVideo = async (event: any) => {
    if (videoState.video?.size > 20000000) {
      enqueueSnackbar("Maximum video size 20mb", {
        variant: "error",
      });
      return;
    }
    const body = new FormData();
    body.append("video", videoState.video);
    body.append("old_video", videoState.old_video);
    setLoadingState(true);
    try {
      await putVideo(QUERY_NAME, body);
      setLoadingState(false);
      setVideoState(initVideoState);
      setIsEditState(false);
      onShowTextAndVideo();
      enqueueSnackbar("Update video Virtual Tour Toll Road Berhasil", {
        variant: "success",
      });
    } catch (err: any) {
      setLoadingState(false);
      enqueueSnackbar(err.message, {
        variant: "error",
      });
    }
  };

  const getData = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_URL}/api/jlp/video?name=${QUERY_NAME}`
      );
      const resJson = await res.json();
      setVideoState({
        ...videoState,
        old_video: resJson.data.filename,
      });
    } catch (err: any) {
      enqueueSnackbar(err.message, {
        variant: "error",
      });
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditState]);

  return (
    <div>
      {!isEditState && (
        <>
          <Button
            variant="contained"
            startIcon={<Edit />}
            color="primary"
            style={{ marginBottom: 16 }}
            size="large"
            onClick={() => {
              onHideText();
              setIsEditState(true);
            }}
          >
            Edit
          </Button>
          {videoState.old_video && (
            <ReactPlayer
              url={`${process.env.REACT_APP_URL}/videos/${videoState.old_video}`}
              playing
              controls
              style={{ maxWidth: "100%" }}
              onError={() => console.log("video error")}
            />
          )}
        </>
      )}

      {isEditState && (
        <>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              variant="outlined"
              startIcon={<VideoCall />}
              color="primary"
              disabled={loadingState}
              size="large"
              style={{
                marginBottom: 16,
              }}
              component="label"
            >
              Upload Video
              <input type="file" onChange={handleVideoChange} hidden />
            </Button>
            <div style={{ marginTop: 16 }}>
              <Button
                color="primary"
                variant="outlined"
                style={{ marginRight: 16 }}
                disabled={loadingState}
                size="large"
                onClick={() => {
                  setVideoState(initVideoState);
                  setIsEditState(false);
                  onShowTextAndVideo();
                }}
              >
                Cancel
              </Button>
              {videoState.videoRead && (
                <Button
                  onClick={handleSaveVideo}
                  size="large"
                  color="primary"
                  variant="contained"
                  disabled={loadingState}
                >
                  {loadingState ? "Loading ..." : "Save"}
                </Button>
              )}
            </div>
          </div>
          {videoState.videoRead && (
            <ReactPlayer url={videoState.videoRead} controls width="auto" />
          )}
        </>
      )}
    </div>
  );
};

export default VideoTentangKami;
